/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {FormattedMessage, injectIntl} from 'react-intl';
import {Button, Grid} from "@scuf/common";
import Loader from "../common/Loader";
import Filter from "./Filter";
import {FLEETS_SORT} from "./FleetsConst";
import {bindActionCreators} from "redux";
import * as FleetActions from "./FleetActions";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import FleetCard from "./FleetCard";
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";
import {Routes} from "../utils/Routes";

class Fleets extends React.Component{

    constructor(props) {
        super(props)

        this.state = {
            filter: {
                search: '',
                sort: FLEETS_SORT.NAME,
            },
        }

        this.searchChanged = this.searchChanged.bind(this)
        this.sortChanged = this.sortChanged.bind(this)
    }

    componentDidMount() {
        this.fetchFleets()
    }

    fetchFleets() {
        this.props.FleetActions.fetchFleets(this.state.filter.search, this.state.filter.sort)
    }

    searchChanged(search) {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                search: search,
            },
        }, this.fetchFleets)
    }

    sortChanged(sort) {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                sort: sort,
            },
        }, this.fetchFleets)
    }

    getFleetCards() {
        return this.props.fleet.fleets.map(f =>
            <Grid.Column width={3} sWidth={12} mWidth={4} key={f.id}><FleetCard fleet={f} /></Grid.Column>)
    }

    getEditButton() {
        const {intl, history} = this.props
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.FLEETS_WRITE)) {
            return <Button content={intl.formatMessage({id: 'link.edit.fleets'})} type="secondary"
                           onClick={() => history.push(Routes.FLEETS_ADMIN)}/>
        }
        return null
    }

    render() {
        const fleetCards = this.getFleetCards()

        return (
            <div id="fleets-list">
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8} sWidth={12}>
                            <h2><FormattedMessage id="page.fleets"/></h2>
                        </Grid.Column>
                        <Grid.Column width={4} sWidth={12}>
                            <div className="right">
                                {this.getEditButton()}
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <div className="fleets-grid">
                    <Loader loading={this.props.fleet.loading}/>
                    <Filter search={this.state.filter.search} searchChanged={this.searchChanged}
                            className="fleets-filter" sort={this.state.filter.sort} sortOptions={FLEETS_SORT}
                            sortChanged={this.sortChanged}/>
                    <Grid>
                        <Grid.Row>
                            {fleetCards}
                        </Grid.Row>
                    </Grid>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fleet: state.fleet,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FleetActions: bindActionCreators(FleetActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Fleets)))